<template>
  <div class="list-header win-drag-bar" ref="listHeader">
    <div class="list-header-operate">
      <!--<a class="logo-cloud" target="_blank" href="https://cloud.tencent.com">腾讯云</a>-->
      <a class="logo" ref="logo" target="_blank" href="https://cloud.tencent.com/document/product/436/11366">
        COSBrowser
      </a>
      <div class="ad-header-corner"></div>
      <div class="tc-g cos-header-operate no-drag-bar">
        <div class="tc-g-u-1-3">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div ref="transport" class="cos-icon--24 transport" @click="onTabClick('transport')"></div>
            <template slot="popup">{{$t('core.transfer')}}</template>
          </qc-bubble>
          <!-- 小红点动画/数字 -->
          <div :class="{'setting-red-wrap':!transportAnimationClass,'bubble-animation':transportAnimationClass}"
            v-show="!transportAnimationStartHide&&(totalNum||transportUnread)">
            <div :class="{'setting-red-number':totalNum,'setting-red-point':totalNum===0}">
              <span v-show="totalNum">{{totalNum > 9999? '9999+' : totalNum}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="tc-g-u-1-4">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div class="cos-icon--24 sync" @click="onTabClick('sync')"></div>
            <template slot="popup">{{$t('core.sync')}}</template>
          </qc-bubble>
        </div> -->
        <div class="tc-g-u-1-3">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div class="cos-icon--24" :class="{'setting': !$store.hasNewVersion, 'setting-new':$store.hasNewVersion}"
              @click="onTabClick('setting')">
            </div>
            <template slot="popup">{{$t('core.setting_advance')}}</template>
          </qc-bubble>
        </div>

        <div class="tc-g-u-1-3">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div class="cos-icon--24 user" @click="onTabClick('account')">
            </div>
            <template slot="popup">{{$t('core.account')}}</template>
          </qc-bubble>
        </div>
      </div>
    </div>

    <!-- dialog -->
    <transport :show.sync="transportShow"></transport>
    <setting :show.sync="settingShow"></setting>
    <account :show.sync="accountShow"></account>
  </div>
</template>

<script>
import _ from 'lodash';

import eventProxy from '@/scripts/tools/eventProxy';

import transport from '@/components/dialog/others/operate/transport/index.vue';
import setting from '@/components/dialog/others/operate/setting/index.vue';
import account from '@/components/dialog/others/operate/account/index.vue';

export default {
  components: {
    account,
    setting,
    transport,
  },
  data() {
    return {
      // hack: 控制传输气泡显示
      transportShow: false,
      clickTransport: false, // 表示是否触发点击动作

      // 控制气泡提示显示
      settingTipShow: true,
      transportTipShow: true,
      syncTipShow: true,

      syncShow: false,
      settingShow: false,
      accountShow: false,

      // 传输气泡动画
      transportAnimationClass: false,
      transportAnimationStartHide: false,
      transportUnread: false,
      transportAnimationStartTime: 0,
      lastFinishSuccessCount: 0,
      lastFinishErrorCount: 0,
      lastFinishTime: '',

      // 计数器
      uploadTransferring: 0,
      downloadTransferring: 0,
      lastTotalNum: 0,
    };
  },
  computed: {
    totalNum() {
      return this.$store.uploadNum + this.$store.downloadNum;
    },
  },
  watch: {
    transportShow(val) {
      if (!val) {
        this.clickTransport = false;
      }
    },
  },
  mounted() {
    // 监听添加上传
    eventProxy.on('upload-add', this.onAdd);
    eventProxy.on('download-add', this.onAdd);
    // 监听数字变化
    eventProxy.on('upload-list-update', this.updateUploadNum);
    eventProxy.on('download-list-update', this.updateDownloadNum);
    // 恢复同步任务
    this.checkSync();
    // 恢复任务列表，会触发首次上传下载列表更新事件
    // cos.restoreTask();
    // downloader.restoreTask();
  },
  beforeDestroy() {
    eventProxy.off('upload-add', this.onAdd);
    eventProxy.on('upload-list-update', this.updateUploadNum);
    eventProxy.off('download-add', this.onAdd);
    eventProxy.on('download-list-update', this.updateDownloadNum);
  },
  methods: {
    /**
     * 检查同步情况，是否开启同步
     */
    checkSync() {
      const { syncStarted, autoSync } = this.$store;
      if (syncStarted && autoSync) {
        // sync.setOptions({ started: true });
        // sync.sync('click');
      }
    },
    onTabClick(name) {
      const tipName = `${name}Show`;
      this[tipName] = true;
      if (name === 'transport') {
        this.transportUnread = false;
      }
    },
    onAdd() {
      const currentTime = Date.now();
      if (currentTime - this.transportAnimationStartTime <= 600) return;
      this.transportUnread = true;
      this.transportAnimationClass = true;
      this.transportAnimationStartHide = true;
      this.transportAnimationStartTime = Date.now();
      setTimeout(() => {
        this.transportAnimationStartHide = false;
      });
      setTimeout(() => {
        this.transportAnimationClass = false;
      }, 600);
    },
    updateUploadNum(data) {
      // 统计每个状态数字
      const stateMap = {};
      if (data) {
        data.list.forEach(item => {
          stateMap[item.state] = (stateMap[item.state] || 0) + 1;
        });
      }
      // 计算未完成数，正在传输数
      let unfinished = 0;
      let transferring = 0;
      _.each(stateMap, (count, state) => {
        if (!['success', 'canceled'].includes(state)) unfinished += count;
        if (['waiting', 'checking', 'uploading'].includes(state)) {
          transferring += count;
        }
      });
      this.$store.uploadNum = unfinished;
      this.uploadTransferring = transferring;
      // 更新界面显示
      this.updateCheckerCount();
    },
    updateDownloadNum(data) {
      // 统计每个状态数字
      const stateMap = {};
      if (data) {
        data.list.forEach(item => {
          stateMap[item.state] = (stateMap[item.state] || 0) + 1;
        });
      }
      // 计算未完成数，正在传输数
      let unfinished = 0;
      let transferring = 0;
      _.each(stateMap, (count, state) => {
        if (state !== 'success') unfinished += count;
        if (['waiting', 'downloading'].includes(state)) transferring += count;
      });
      this.$store.downloadNum = unfinished;
      this.downloadTransferring = transferring;
      // 更新界面显示
      this.updateCheckerCount();
    },
    updateCheckerCount() {
      eventProxy.emit('checker.count', {
        unfinished: this.totalNum,
        transferring: this.uploadTransferring + this.downloadTransferring,
      });
      // 如果有数字，突然变成没数字，并且没打开传输弹窗，显示红点
      if (this.lastTotalNum && !this.totalNum && this.transportShow) {
        this.transportUnread = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ad-header-corner {
  flex-grow: 2;
  margin-right: 15px;
}
</style>
<style lang="scss" scoped>
.custom-bubble {
  ::v-deep .popup {
    max-width: 900px;
  }
  ::v-deep .tc-15-bubble-inner {
    box-shadow: 0 2px 10px 0 rgba(12, 12, 13, 0.24);
    border-radius: 2px;
  }
  ::v-deep &.pd-0 {
    .tc-15-bubble-inner {
      padding: 0;
      border: 0;
    }
  }
}
</style>
